import dynamic from "next/dynamic";

interface Props {
  centerId: string;
}
const BankLogo = dynamic(() => import("./logos"), {
  ssr: false,
});

const BankLogoComponent = ({ centerId }: Props) => <BankLogo centerId={centerId} />;

export default BankLogoComponent;
